export const SUPPORT_MESSAGE_TYPES = {
  CREW_NEVER_SHOWED_UP: 'Crew never showed up',
};

export default {
  SUPPORT_MESSAGE_TYPES,
};
